import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt, Redirect } from 'react-router';
import { Button, Col, FormGroup, Label, Row } from 'reactstrap';
import { UserStore } from 'src/Stores/User/UserStore';
import { IWarehouse } from '../../../../Interfaces/AdminInterface';
import ButtonRow from '../../../ButtonRow';
import { EButton, EInput } from '../../../EInput';


@inject('stores')
@observer
class AdminWarehouseDetails extends React.Component {

    public props: any;
    public warehouse: IWarehouse = new IWarehouse();
    public warehouseDisposer: any;
    public adminStore: any;
    public MessageStore: any;
    public UserStore: UserStore;

    public state = {
        isDirty: false,
        redirect: false,
        warehouse: this.warehouse,
        warehouseId: '',
    };

    constructor(props: any) {
        super(props);

        this.adminStore = this.props.stores.AdminStore;
        this.MessageStore = this.props.stores.MessageStore;
        this.UserStore = props.stores.UserStore;
        this.handleChange = this.handleChange.bind(this);
        this.handleSaveWarehouse = this.handleSaveWarehouse.bind(this);
        this.removeWarehouse = this.removeWarehouse.bind(this);
    }

    public componentDidMount() {
        this.createDisposers();

        this.setState({
            warehouseId: this.props.match.params.id,
        }, () => {
            if ( this.state.warehouseId !== 'new' ) {
                this.adminStore.getWarehouse(this.props.match.params.id);
            }
        });
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public createDisposers() {
        this.warehouseDisposer = intercept(this.adminStore, 'warehouse', (change: any) => {
            this.setState({
                warehouse: change.newValue
            });

            return change;
        });
    }

    public clearDisposers() {
        this.warehouseDisposer();
    }

    public handleChange(event: any) {
        const warehouse = this.state.warehouse;

        warehouse[event.target.name] = event.target.value;

        this.setState({
            isDirty: true,
            warehouse
        });
    }

    public handleSaveWarehouse() {
        this.adminStore.saveWarehouse(this.state.warehouse)
            .then(
                (data: any) => {
                    this.setState({
                        redirect: true
                    });

                    this.MessageStore.addMessage(
                        'Changes have been saved',
                        'success'
                    );
                },
                (error: any) => {
                    this.MessageStore.addMessage(
                        error.toString(),
                        'danger'
                    );
                }
            );
    }

    public removeWarehouse() {
        this.adminStore.deleteWarehouse(this.state.warehouse)
            .then(
                (data: any) => {
                    this.setState({
                        redirect: true
                    });

                    this.MessageStore.addMessage(
                        'Warehouse Successfully Deleted',
                        'success'
                    );
                }
            );
    }

    public render() {
        return(
            this.state.redirect ? (
                <Redirect to="/admin/warehouses" />
            ) : (
                <div>
                    <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                    <Row>
                        <Col md="6">
                            <FormGroup className="required">
                                <Label>Name</Label>
                                <EInput
                                    type="text"
                                    name="name"
                                    required={true}
                                    value={this.state.warehouse.name}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Phone</Label>
                                <EInput
                                    type="text"
                                    name="phone"
                                    data-mask="phone"
                                    value={this.state.warehouse.phone}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Address 1</Label>
                                <EInput
                                    type="text"
                                    name="addr1"
                                    value={this.state.warehouse.addr1}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Address 2</Label>
                                <EInput
                                    type="text"
                                    name="addr2"
                                    value={this.state.warehouse.addr2}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>City</Label>
                                <EInput
                                    type="text"
                                    name="city"
                                    value={this.state.warehouse.city}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>State</Label>
                                <EInput
                                    type="text"
                                    name="state"
                                    value={this.state.warehouse.state}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Zip</Label>
                                <EInput
                                    type="text"
                                    name="zip"
                                    value={this.state.warehouse.zip}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <ButtonRow>
                        {
                            this.UserStore.hasPermission('Permissions.Admin.Warehouses.Delete') &&
                            <Button color="danger" onClick={this.removeWarehouse}>Delete Warehouse</Button>
                        }
                        {
                            (this.state.warehouse.id === '' ?
                            this.UserStore.hasPermission('Permissions.Admin.Warehouses.Create')
                            :
                            this.UserStore.hasPermission('Permissions.Admin.Warehouses.Update'))
                            &&
                            <EButton color="primary" onClick={this.handleSaveWarehouse}>Save Warehouse</EButton>
                        }
                    </ButtonRow>
                </div>
            )
        );
    }
}

export default AdminWarehouseDetails;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Warehouses/AdminWarehouseDetails.tsx